function InitSlideshow() {
    document.querySelectorAll('.slideshow').forEach(function(slideshow, slideshowId) {
        let slideIndex = 0;
        let slides = slideshow.querySelectorAll('.slide')
        
        if(slides.length > 1) {
            // Create dots
            const dotsContainer = document.createElement('div');
            dotsContainer.classList.add('dots');
            
            for (let i = 0; i < slides.length; i++) {
                let dot = ''
            if (i == 0) {
                dot = `<div class="dot active"></div>`;
            } else {
                dot = `<div class="dot"></div>`;
            }
                dotsContainer.insertAdjacentHTML("beforeend", dot);
            }
            // Append dots to slideshow
            slideshow.appendChild(dotsContainer);
        }
        
        // Add click event on each dot
        const dots = slideshow.querySelectorAll('.dot');
        dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                currentSlide(i);
            })
        });

        const timer = 3500;
        // Init shown slides
        showSlides(slideIndex);
        setTimeout(() => {
            slideshowTimer()
        }, timer);

        function slideshowTimer() {                  
            if (slideIndex < slides.length - 1) {
                currentSlide(slideIndex + 1)
                setTimeout(slideshowTimer, timer);
            } else {
                slideIndex = 0;
                showSlides(slideIndex);
                setTimeout(slideshowTimer, timer); 
            }
        }

        // Swipe functionality calling the currentSlide()
        let touchstartX = 0;
        let touchendX = 0;

        function checkDirection() {
            if (touchendX < touchstartX) {
                if (slideIndex < slides.length - 1) {
                    currentSlide(slideIndex + 1)
                }
            }
            
            if (touchendX > touchstartX) {
                if (slideIndex > 0) {
                    currentSlide(slideIndex - 1);
                }
            }
        }

        slideshow.addEventListener('touchstart', e => {
            touchstartX = e.changedTouches[0].screenX
        })

        slideshow.addEventListener('touchend', e => {
            touchendX = e.changedTouches[0].screenX
            checkDirection()
        })


        // Decide which slide is the current slide
        function currentSlide(n) {
            showSlides(slideIndex = n)
        }

        // Function for which slide is shown
        function showSlides(n) {
            if (n > slides.length) {
                slideIndex = 0
            }

            if (n < 0) {
                slideIndex = slides.length
            }
            for (let i = 0; i < slides.length; i++) {
                const element = slides[i];
                element.classList.remove('show')
            }
            for (let x = 0; x < dots.length; x++) {
                dots[x].className = dots[x].className.replace(" active", ""); 
            }
            
            slides[slideIndex].classList.add('show');
            if(dots.length > 0)
                dots[slideIndex].className += " active";
        }
    })
}